import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

import {
  QualityGatesApi,
  QualityGatesResponse,
  SonarInstanceName,
} from './QualityGatesApi';

/**
 * Client implementation for Quality Gates API
 */
export class QualityGatesClient implements QualityGatesApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getQualityGates(
    organization: string,
    instance: SonarInstanceName = 'default',
  ): Promise<QualityGatesResponse> {
    try {
      const baseUrl = await this.discoveryApi.getBaseUrl('quality-gates');
      const params = new URLSearchParams({
        organization,
        instance,
      });
      const url = `${baseUrl}/gates?${params.toString()}`;

      const response = await this.fetchApi.fetch(url);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const error = new Error(
          errorData.message ||
            `Failed to fetch quality gates: ${response.statusText}`,
        ) as Error & { status?: number; statusCode?: number };
        error.status = errorData.statusCode || response.status;
        error.statusCode = errorData.statusCode || response.status;
        throw error;
      }

      return (await response.json()) as QualityGatesResponse;
    } catch (error: any) {
      // H4: avoid double-wrapping messages we already created
      if (
        typeof error?.message === 'string' &&
        error.message.startsWith('Failed to fetch quality gates')
      ) {
        throw error;
      }
      const newError = new Error(
        `Failed to fetch quality gates: ${error.message}`,
      ) as Error & { status?: number; statusCode?: number };
      if (error.status) newError.status = error.status;
      if (error.statusCode) newError.statusCode = error.statusCode;
      throw newError;
    }
  }
}
